export default __webpack_public_path__ + "static/article-5-tips-for-finding-the-best-shopping-deals-0aa418297dc73d3abaf0eb6a1bb8701e.jpg";